import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { GraphService } from '../services/graph.service';
import { AuthService } from '../services/auth.service';
import { MsalModule } from '@azure/msal-angular';
import { OAuthSettings } from '../Ms Grapgh API files/oauth';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionSignupB2cComponent } from './subscription-signup-b2c/subscription-signup-b2c.component';


const routes: Routes = [
  { path: '', redirectTo: 'dpm-signupflow', pathMatch: 'full' },
  { path: '', component: SubscriptionSignupB2cComponent },
]


@NgModule({
  declarations: [SubscriptionSignupB2cComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbModule,
    RouterModule.forChild(routes),
    MsalModule.forRoot({
      auth: {
        clientId: OAuthSettings.appId
      }
    })
  ],
  exports: [
    RouterModule,
    SharedModule
  ],
  providers: [
    GraphService,
    AuthService,
  ]
})
export class Signupmoduleb2cModule { }
